export const getNewProjectSpecialNote = (state) => {
  return state.pages.projectView.modalData.specialNote.specialNote;
};
